import React from 'react';
import { combineReducers } from 'redux';
import { put, select, takeEvery } from 'redux-saga/effects';
import get from 'lodash.get';
import { SAVE_PREFERENCES_SUCCESS } from './preferences';
import { SEND_WEEK_EMAIL_SUCCESS } from './workouts';
import { SAVE_EVENTS_SUCCESS } from './events';
import { CHANGE_PLAN_SUCCESS } from './race';
import { SAVE_LOG_SUCCESS, DELETE_LOG_SUCCESS } from './log';
import { SAVE_PROFILE_SUCCESS, CONTACT_US_SUCCESS } from './profile';
import isMobile from '../utils/isMobile';
import Markdown from '../Components/Markdown';

export const OPEN_TOAST_POPUP = 'toasts/OPEN_TOAST_POPUP';
export const CLOSE_TOAST_POPUP = 'toasts/CLOSE_TOAST_POPUP';

const initialState = {
    open: false,
    message: '',
};

export function toastInfo(state = initialState, action) {
    switch (action.type) {
        case OPEN_TOAST_POPUP:
            return {
                open: true,
                message: action.message,
            };
        case CLOSE_TOAST_POPUP:
            return initialState;
        default:
            return state;
    }
}

export default combineReducers({ toastInfo });

// Watchers on Actions that triggers Toasts

export function* watchSuccessEmail() {
    yield takeEvery(SEND_WEEK_EMAIL_SUCCESS, showEmailSuccessToast);
}

export function* watchSuccessEvents() {
    yield takeEvery(SAVE_EVENTS_SUCCESS, showEventsSuccessToast);
}

export function* watchSuccessLog() {
    yield takeEvery(SAVE_LOG_SUCCESS, showLogSuccessToast);
}

export function* watchSuccessDeleteLog() {
    yield takeEvery(DELETE_LOG_SUCCESS, showDeleteLogSuccessToast);
}

export function* watchChangeTrainingPlanSuccess() {
    yield takeEvery(CHANGE_PLAN_SUCCESS, showPlanChangedSuccessToast);
}

export function* watchSuccessPreferences() {
    yield takeEvery(SAVE_PREFERENCES_SUCCESS, showPreferencesSuccessToast);
}

export function* watchProfileSaving() {
    yield takeEvery(SAVE_PROFILE_SUCCESS, () =>
        put(openToast('Your profile update has been saved')),
    );
}

export function* watchContactUsSuccess() {
    yield takeEvery(CONTACT_US_SUCCESS, () =>
        put(openToast('Thank you for contacting RUNtrix')),
    );
}

export function* showEmailSuccessToast() {
    const { profile } = yield select();
    const emailMsg = isMobile() ?
            'We’ve emailed your workout' :
            `We’ve emailed your workout to:  ${profile.values.email}`;
    return yield put(openToast(emailMsg));
}

export function* showPlanChangedSuccessToast(action) {
    const changePlanMessage = get(action, 'result.message', 'You have successfully changed your training plan level.');
    return yield put(openToast(changePlanMessage));
}

export function* showEventsSuccessToast(action) {
    const saveEventMessage = get(action, 'result[0].message', '');
    if (saveEventMessage) {
        return yield put(openToast(<Markdown content={saveEventMessage.replace(/\\/g, '')} />));
    }
    return null;
}

export function* showLogSuccessToast(action) {
    const logAddEditMessage = get(action, 'result[0].message', '');
    if (logAddEditMessage) {
        return yield put(openToast(logAddEditMessage));
    }
    return null;
}

export function* showDeleteLogSuccessToast() {
    const logDeletedMessage = 'Your log entry has been deleted.';
    return yield put(openToast(logDeletedMessage));
}

export function* showPreferencesSuccessToast() {
    const preferencesMsg = 'Your RUNtrix plan has been updated!';
    // This will be commented for now, Seamus needs to decide how it will look like
    // const emailMsg = isMobile() ?
    //         'Your RUNtrix plan has been updated!' :
    //         'Your RUNtrix plan based on your logging history. Happy running!';
    return yield put(openToast(preferencesMsg));
}

export function* rootSaga() {
    yield [
        watchSuccessEmail(),
        watchSuccessEvents(),
        watchContactUsSuccess(),
        watchSuccessPreferences(),
        watchProfileSaving(),
        watchSuccessPreferences(),
        watchChangeTrainingPlanSuccess(),
        watchSuccessLog(),
        watchSuccessDeleteLog(),
    ];
}
export const openToast = message => ({
    type: OPEN_TOAST_POPUP,
    message,
});

export const hideToast = () => ({
    type: CLOSE_TOAST_POPUP,
});



/** WEBPACK FOOTER **
 ** ./src/redux/toasts.js
 **/